import { render, staticRenderFns } from "./orderComponent.vue?vue&type=template&id=5c31d889&"
import script from "./orderComponent.vue?vue&type=script&lang=js&"
export * from "./orderComponent.vue?vue&type=script&lang=js&"
import style0 from "./orderComponent.vue?vue&type=style&index=0&id=5c31d889&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports